export const coupons_endpoints = {
  endpoints: (build) => ({
    getCoupons: build.query({
      query: () => ({
        url: "coupons/",
        method: "GET",
      }),
      providesTags: ["Coupons"],
    }),
    getCoupon: build.query({
      query: (id) => ({
        url: `coupons/${id}`,
        method: "GET",
      }),
      providesTags: ["Coupons"],
    }),
    createCoupon: build.mutation({
      query: (body) => ({
        url: "coupons/",
        method: "POST",
        body,
        formData: true,
      }),
      invalidatesTags: ["Coupons"],
    }),
    updateCoupon: build.mutation({
      query: ({ id, body, formData }) => {
        return {
          url: `coupons/${id}/`,
          method: "PATCH",
          body: body || formData,
          formData: Boolean(formData),
        };
      },
      invalidatesTags: ["Coupons"],
    }),
    deleteCoupon: build.mutation({
      query: (id) => ({
        url: `coupons/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Coupons"],
    }),
  }),
};
